import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Instalment, InstalmentListResponse, InstalmentRequest } from './types'

export const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'id') {
        return ['id', item[1]?.toLowerCase()]
      } else if (item[0] === 'addedAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const instalmentsListMounted = createEvent<InstalmentRequest>()

export const getInstalmentList = fx<InstalmentRequest, InstalmentListResponse>({
  method: 'GET',
  url: `/nova/installment`,
})

export const $instalments = restore<Instalment[]>(
  getInstalmentList.doneData.map((a) => {
    return a.body.items.map((item) => {
      return { ...item }
    })
  }),
  [],
)

export const $totalCountOfInstalments = restore(
  getInstalmentList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: instalmentsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    if (orderBy == 'installmentId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }
    // @ts-ignore
    if (orderBy != '') {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }
    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status' || key === 'backendStatus'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    // @ts-ignore
    query['populate'] = '["Installment.user"]'
    return {
      query,
    }
  },
  target: getInstalmentList,
})
